import { GET_MEETING_DETAILS, UPDATE_GOOGLE_CALENDAR_MEETING, UPDATE_OUTLOOK_CALENDAR_MEETING, UPDATE_STATUS_ATTENDEE, GET_MONTHLY_MEETING } from "./constants";

export function getMeetingDetails(appointmentId) {
  return {
    type: GET_MEETING_DETAILS,
    appointmentId,
  };
}

export function getMonthlyMeeting(month,year) {
  return {
    type: GET_MONTHLY_MEETING,
    month,
    year
  };
}

export function updateAttendeeStatus(payload, onSuccess) {
  return {
    type: UPDATE_STATUS_ATTENDEE,
    payload,
    onSuccess
  };
}

export function UpdateMeetingInGoogleCalendar(payload, onSuccessAlert) {
  return {
    type: UPDATE_GOOGLE_CALENDAR_MEETING,
    payload,
    onSuccessAlert
  };
}

export function UpdateMeetingInOutlookCalendar(payload, onSuccessAlert) {
  return {
    type: UPDATE_OUTLOOK_CALENDAR_MEETING,
    payload,
    onSuccessAlert
  };
}
